// extracted by mini-css-extract-plugin
module.exports = {"label":"label-3-96P","radio":"radio-2He06","active":"active-1PfAp"};